import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import tw from 'twin.macro'

import { PAGEBUILDER_CHECKOUT_PAGE, PAGEBUILDER_SALES_PAGE, PRICING } from 'modules/App/components/Header'
import { AlertProvider } from 'common/components/Alert/context'

const productNav = [
  { id: 0, title: 'Pricing', link: PRICING },
  { id: 1, title: 'Sales Page', link: PAGEBUILDER_SALES_PAGE },
  { id: 2, title: 'Checkout Page', link: PAGEBUILDER_CHECKOUT_PAGE },
]

export default function ProductLayout({ children }) {
  const { pathname } = useLocation()

  return (
    <AlertProvider>
      <div className='flex flex-col min-h-screen bg-offWhite px-4 md:px-16 pb-48'>
        <div className='w-full max-w-[90rem] mx-auto mt-6 md:mt-12'>
          <h1 className='font-bold text-3xl md:text-5xl text-tBlack capitalize mb-6'>App Subscription</h1>
          <div className='flex items-center justify-start bg-white rounded-lg justify-self-start p-3 border-2 border-gray-200'>
            {productNav.map((item) => (
              <Link
                key={item.id}
                css={[
                  tw`font-semibold text-gray-500 hover:text-black transition-all px-6 py-2 rounded-lg`,
                  pathname === item.link && tw`bg-gray-100 text-black`,
                ]}
                to={item.link}
              >
                {item.title}
              </Link>
            ))}
          </div>
          {children}
        </div>
      </div>
    </AlertProvider>
  )
}
